var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 589,
    height: 80,
    viewBox: "0 0 589 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.6884C0 17.7715 17.7672 0.00427246 39.6841 0.00427246H43.4045C45.0026 0.00427246 46.2981 1.2998 46.2981 2.8979V76.4788C46.2981 78.077 45.0026 79.3725 43.4045 79.3725H39.6841C17.7672 79.3725 0 61.6053 0 39.6884Z",
    fill: "#FF7122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1402 74.412C66.1402 33.3177 99.4536 0.00427246 140.548 0.00427246C143.287 0.00427246 145.508 2.22517 145.508 4.96479V72.7585C145.508 76.4113 142.547 79.3725 138.894 79.3725H71.1007C68.3611 79.3725 66.1402 77.1516 66.1402 74.412Z",
    fill: "#FF9A2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.35 6.61829C165.35 2.96547 168.312 0.00427246 171.964 0.00427246H211.649C215.301 0.00427246 218.263 2.96547 218.263 6.61829V72.7585C218.263 76.4113 215.301 79.3725 211.649 79.3725H171.964C168.312 79.3725 165.35 76.4113 165.35 72.7585V6.61829Z",
    fill: "#FFBE2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M238.105 39.6884C238.105 17.7715 255.872 0.00427246 277.789 0.00427246C299.706 0.00427246 317.473 17.7715 317.473 39.6884C317.473 61.6053 299.706 79.3725 277.789 79.3725C255.872 79.3725 238.105 61.6053 238.105 39.6884Z",
    fill: "#83E4DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M337.315 71.8763V7.5155C337.315 0.837096 345.389 -2.50746 350.112 2.21489L414.472 66.5757C419.195 71.298 415.85 79.3725 409.172 79.3725H344.811C340.671 79.3725 337.315 76.0163 337.315 71.8763Z",
    fill: "#00ABB3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M436.525 26.4603C436.525 11.8491 448.37 0.00427246 462.981 0.00427246C477.592 0.00427246 489.437 11.8491 489.437 26.4603V52.9164C489.437 67.5277 477.592 79.3725 462.981 79.3725C448.37 79.3725 436.525 67.5277 436.525 52.9164V26.4603Z",
    fill: "#005964"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M509.279 6.61829C509.279 2.96547 512.24 0.00427246 515.893 0.00427246H582.034C585.686 0.00427246 588.648 2.96547 588.648 6.61829V72.7585C588.648 76.4113 585.686 79.3725 582.034 79.3725H515.893C512.24 79.3725 509.279 76.4113 509.279 72.7585V6.61829Z",
    fill: "#002021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection3);
export default __webpack_public_path__ + "static/media/section3.d95db7dce6a4a689b3e97c3e8dfcacd7.svg";
export { ForwardRef as ReactComponent };